import { Link } from 'react-router-dom'

export function BtnGhost({ to, children, className = '' }) {
  return (
    <Link
      to={to}
      className={`inline-block bg-transparent text-ds-text border-[1.5px] border-ds-border-mid font-display font-bold text-[13px] tracking-btn uppercase px-6 py-3 rounded-sharp no-underline hover:border-ds-muted transition-colors duration-150 ${className}`}
    >
      {children}
    </Link>
  )
}
